var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0244 2.84766H14.0957V5.42996H16.7187V7.18756H14.0957V8.90535H16.6919V10.6361H14.0957V12.3669H16.6919V14.0977H14.0957V15.8284H16.6919V17.5592H14.0957V20.1553H22.0244C22.4233 20.1553 22.7495 19.817 22.7495 19.4025V3.60054C22.7495 3.18602 22.4233 2.84766 22.0244 2.84766ZM21.0188 17.5592H17.5572V15.8284H21.0188V17.5592ZM21.0188 14.0977H17.5572V12.3669H21.0188V14.0977ZM21.0188 10.6361H17.5572V8.90535H21.0188V10.6361ZM21.0188 7.17458H17.5572V5.44381H21.0188V7.17458Z",
    fill: "#1E6E42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 2.7501V20.2508L13.2308 22.75V0.25L0.25 2.7501ZM8.46077 15.8962L6.95067 13.0413C6.89356 12.9348 6.83471 12.7392 6.77327 12.4545H6.7499C6.72135 12.5887 6.65385 12.7929 6.5474 13.0663L5.03212 15.8962H2.67913L5.4726 11.5138L2.91712 7.13067H5.31942L6.5725 9.75885C6.67029 9.96654 6.75769 10.2132 6.83558 10.4979H6.85981C6.90913 10.3265 7.00087 10.0721 7.135 9.73375L8.52827 7.12981H10.7281L8.0999 11.4758L10.8016 15.8953L8.46077 15.8962Z",
    fill: "#1E6E42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIcon);
export default __webpack_public_path__ + "static/media/excelIcon.3a19f77d28c3e5ca3054d6b0750586dd.svg";
export { ForwardRef as ReactComponent };